import { ButtonType, DialogFooterButtonsWidget, TextFieldWidget, TextLinkWidget } from '@tableau/widgets';
import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Messages } from '~src/codegen/Localize';
import { CloseAndDismiss } from '~src/commonInfra/dialogs/ReactModalService';
import { DialogFieldParentStyle, DialogTextFieldStyle } from '~src/commonInfra/dialogs/style/DialogStyles';
import { HelpService } from '~src/commonInfra/services/HelpService';
import { ToasterService, ToastType } from '~src/commonInfra/services/ToasterService';
import { MapDispatchToProps } from '~src/commonInfra/utils/ConnectUtils';
import { getCredentialEncryptionKeyRequest } from '~src/settings/security-settings/sections/credential-encryption/actions/GetCredentialEncryptionKeyRequestAction';
import { learnMoreStyle } from '~src/settings/styles/CommonStyles';

import { getExtractEncryptionKeyRequest } from '../actions/GetExtractEncryptionKeyRequestAction';
import { DeactivateSiteEncryptionKeyRequest, DeactivateSiteEncryptionKeyResult } from '../serverApi/requests/DeactivateSiteEncryptionKeyRequest';
import { deactivateSiteEncryptionKey } from '../services/ExtractEncryptionKeyService';


export interface KMSKeyDeactivateViewOwnProps {
    closeDialog: CloseAndDismiss;
    externalKeyId: string;
}

export interface KMSKeyDeactivateViewDispatchProps {
    retrieveExtractEncryptionKey: () => void;
    retrieveCredentialEncryptionKey: () => void;
}

export type KMSKeyDeactivateViewProps = KMSKeyDeactivateViewOwnProps & KMSKeyDeactivateViewDispatchProps;


export interface KMSKeyDeactivateViewState {
    isDeactivatingKey: boolean;
    validationText: string;
}

export class KMSKeyDeactivateViewComponent extends React.PureComponent<KMSKeyDeactivateViewProps, KMSKeyDeactivateViewState> {

    constructor(props: KMSKeyDeactivateViewProps) {
        super(props);
        this.state = {
            isDeactivatingKey: false,
            validationText: ''
        };
    }


    public render(): JSX.Element {
        return <>
            <div style={DialogFieldParentStyle}>
                <span>{Messages.extractEncryption_KMSKeyDeactivateDialog_Description()}
                    <TextLinkWidget
                        testId={'kms-key-deactivate-learn-more'}
                        target={'_blank'}
                        href={HelpService.getHelpUrlByCategory('online-kms-external-deactivate-key')}
                        className={learnMoreStyle}>
                        {Messages.learnMore()}
                    </TextLinkWidget>
                </span>
            </div>
            <br></br>
            <div style={DialogFieldParentStyle}>{Messages.extractEncryption_KMSKeyDeactivateDialog_Warning()}</div>
            <ul style={{paddingLeft: '20px'}}>
                <li id="kms-key-deactivate-terms-1">{Messages.extractEncryption_KMSKeyDeactivateDialog_Warning_1()}</li>
                <li id="kms-key-deactivate-terms-2">{Messages.extractEncryption_KMSKeyDeactivateDialog_Warning_2()}</li>
            </ul>
            <br></br>
            <div id="kms-key-deactivate-validation-message">
                {Messages.extractEncryption_KMSKeyDeactivateDialog_validation_message({MESSAGE: Messages.extractEncryption_KMSKeyDeactivateDialog_validation_confirmation_text()})}
            </div>
            <br></br>
            <div style={DialogFieldParentStyle}>
                <TextFieldWidget
                    label={Messages.extractEncryption_KMSKeyDeactivateDialog_validation_label()}
                    testId="kms-key-deactivate-validation-text"
                    value={this.state.validationText}
                    className={DialogTextFieldStyle}
                    onChange={(e) => this.setState({validationText: e.target.value})}
                />
            </div>
            <div style={{ position: 'relative' }}>
                <DialogFooterButtonsWidget
                    buttons={[
                        {
                            buttonType: ButtonType.Outline,
                            children: Messages.cancel(),
                            onClick: this.props.closeDialog.close,
                            testId: 'cancel-button'
                        },
                        {
                            buttonType: ButtonType.Destructive,
                            showSpinner: this.state.isDeactivatingKey,
                            children: Messages.extractEncryption_KMSKeyDeactivateDialog_Deactivate_button(),
                            disabled: this.state.validationText !== Messages.extractEncryption_KMSKeyDeactivateDialog_validation_confirmation_text(),
                            onClick: () => this.deactivateKey(),
                            testId: 'deactivate-button'
                        }
                    ]}
                />
            </div>
        </>;
    }

    private deactivateKey() {
        this.setState({isDeactivatingKey: true}, () => {
            deactivateSiteEncryptionKey(new DeactivateSiteEncryptionKeyRequest({externalKeyId: this.props.externalKeyId}))
            .then((response: DeactivateSiteEncryptionKeyResult) => {
                if(response.errors){
                    ToasterService.instance.pop({ type: ToastType.Error, text: Messages.extractEncryption_KMSKeyDeactivateDialog_FailureToast() });
                } else {
                    ToasterService.instance.pop({ type: ToastType.Success, text: Messages.extractEncryption_KMSKeyDeactivateDialog_SuccessToast() });
                    this.props.retrieveExtractEncryptionKey();
                    this.props.retrieveCredentialEncryptionKey();
                }
            }).catch(() => {
                ToasterService.instance.pop({ type: ToastType.Error, text: Messages.extractEncryption_KMSKeyDeactivateDialog_FailureToast() });
            }).finally(() => {
                this.setState({isDeactivatingKey: false});
                this.props.closeDialog.close();
            });
        });
    }
}

const mapDispatchToProps: MapDispatchToProps<KMSKeyDeactivateViewDispatchProps> =
  (dispatch) => bindActionCreators({
    retrieveExtractEncryptionKey: getExtractEncryptionKeyRequest,
    retrieveCredentialEncryptionKey: getCredentialEncryptionKeyRequest
  },
  dispatch);

export const KMSKeyDeactivateView: React.ComponentClass<KMSKeyDeactivateViewOwnProps> =
  connect(undefined, mapDispatchToProps)(KMSKeyDeactivateViewComponent);